import { render, staticRenderFns } from "./CodeAndControls.vue?vue&type=template&id=c83f5760&scoped=true&"
import script from "./CodeAndControls.vue?vue&type=script&lang=js&"
export * from "./CodeAndControls.vue?vue&type=script&lang=js&"
import style0 from "./CodeAndControls.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CodeAndControls.vue?vue&type=style&index=1&id=c83f5760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83f5760",
  null
  
)

export default component.exports